import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(marketing)/pricing/page.tsx");
